import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import moment from 'moment';
import { DoctorService } from '@/services/doctor.service';
import { REASSIGNMENT_DISABLED_IN_OPTIONS } from '@/constants/doctors';
import { REASSIGNMENT_TYPE } from '@/constants/ooo';
export default {
  props: {
    rowData: {
      type: Object,
      default() {
        return {};
      }
    },
    mode: {
      type: String,
      default: 'edit'
    }
  },
  data() {
    return {
      showDialog: false,
      doctorData: {},
      buttonDisabled: false,
      alert: {
        show: false,
        message: ''
      },
      selectedAll: false,
      doctorsByState: [],
      selectedDoctors: [],
      reassignmentOptions: [{
        text: 'Temporary',
        value: 'TEMPORARY'
      }, {
        text: 'Permanent',
        value: 'PERMANENT'
      }],
      reassignmentType: '',
      outFrom: '',
      outFromTime: '',
      outTo: '',
      outToTime: '',
      fetchVersion: 0,
      loadingDoctors: false,
      dialogReady: false
    };
  },
  computed: {
    submitButtonText() {
      return this.mode == 'approve' ? 'Approve' : 'Confirm';
    },
    selectedDoctorsList() {
      return this.doctorsByState.filter((_, index) => this.selectedDoctors[index] != null);
    },
    isReadOnly() {
      return this.mode === 'view';
    },
    minDate() {
      return moment().format('YYYY-MM-DD');
    },
    fromMs() {
      if (!this.outFrom || !this.outFromTime) {
        return undefined;
      }
      return moment(`${this.outFrom} ${this.outFromTime}`, 'YYYY-MM-DD HH:mm:ss').valueOf();
    },
    toMs() {
      if (!this.outTo || !this.outToTime) {
        return undefined;
      }
      return moment(`${this.outTo} ${this.outToTime}`, 'YYYY-MM-DD HH:mm:ss').valueOf();
    }
  },
  watch: {
    async showDialog(show) {
      if (show) {
        this.dialogReady = false;
        const {
          data
        } = await DoctorService.getReassignment(this.rowData.id);
        this.doctorData = data;
        this.reassignmentType = this.doctorData.assignmenttype;

        // Get Date and Time
        this.outFrom = moment(this.doctorData.startdatestamp * 1000).format('YYYY-MM-DD');
        this.outFromTime = moment(this.doctorData.startdatestamp * 1000).format('HH:mm:ss');
        this.outTo = moment(this.doctorData.enddatestamp * 1000).format('YYYY-MM-DD');
        this.outToTime = moment(this.doctorData.enddatestamp * 1000).format('HH:mm:ss');
        const states = this.doctorData.coveredstate.map(state => state.state);
        this.loadingDoctors = true;
        try {
          const {
            data: doctorList
          } = await DoctorService.getDoctorsByStateV2(states, this.toMs, this.fromMs, REASSIGNMENT_DISABLED_IN_OPTIONS.OOO, this.reassignmentType);
          const docToRemove = this.doctorData.doctorid;
          this.doctorsByState = doctorList.filter(val => {
            var _val$reassignment_dis, _val$reassignment_dis2;
            return val.id !== docToRemove && (val.override_reassignment_rule || !((_val$reassignment_dis = val.reassignment_disabled_in) !== null && _val$reassignment_dis !== void 0 && _val$reassignment_dis.includes(REASSIGNMENT_DISABLED_IN_OPTIONS.OOO)) && (this.reassignmentType !== REASSIGNMENT_TYPE.PERMANENT || !((_val$reassignment_dis2 = val.reassignment_disabled_in) !== null && _val$reassignment_dis2 !== void 0 && _val$reassignment_dis2.includes(REASSIGNMENT_DISABLED_IN_OPTIONS.PERMANENT_REASSIGNMENT))));
          });
        } finally {
          this.loadingDoctors = false;
        }
        await this.$nextTick();

        // Build full array and assign once so Vue 2 reactivity tracks the change
        const selected = new Array(this.doctorsByState.length).fill(null);
        for (const index in this.doctorsByState) {
          if (this.doctorData.doctorlistdetails.find(o => o.doctorid == this.doctorsByState[index].id)) {
            selected[index] = this.doctorsByState[index].id;
          }
        }
        this.selectedDoctors = selected;
        this.dialogReady = true;
        await this.$nextTick();
      } else {
        this.alert.show = false;
        this.buttonDisabled = false;
        this.dialogReady = false;
        this.doctorData = {};
        this.doctorsByState = [];
        this.selectedDoctors = [];
        this.selectedAll = false;
        this.reassignmentType = '';
        this.outFrom = '';
        this.outTo = '';
        this.outFromTime = '';
        this.outToTime = '';
        this.loadingDoctors = false;
      }
    },
    selectedAll(selected) {
      this.selectedDoctors = selected ? this.doctorsByState.map(d => d.id) : [];
    },
    async fromMs(newVal, oldVal) {
      if (newVal !== oldVal && this.dialogReady) {
        await this.refreshDoctorList();
      }
    },
    async toMs(newVal, oldVal) {
      if (newVal !== oldVal && this.dialogReady) {
        await this.refreshDoctorList();
      }
    },
    async outTo(newVal, oldVal) {
      if (newVal !== oldVal) {
        await this.refreshDoctorList();
      }
    },
    async outFrom(newVal, oldVal) {
      if (newVal !== oldVal) {
        await this.refreshDoctorList();
      }
    }
  },
  methods: {
    showAlert(msg) {
      this.alert.message = msg;
      this.alert.show = true;
    },
    getSecondsFromTime(time) {
      const timeArray = time.split(':');
      const hours = timeArray[0];
      const minutes = timeArray[1];
      const secondsInHours = Number(hours) * 60 * 60;
      const secondsInMinutes = Number(minutes) * 60;
      return secondsInHours + secondsInMinutes;
    },
    getMatchingStates(doctor) {
      if (!doctor.coveredstate || !this.doctorData.coveredstate) {
        return '';
      }
      const reassignmentStateList = this.doctorData.coveredstate.map(s => s.state);
      const matchingStates = doctor.coveredstate.filter(state => reassignmentStateList.includes(state.state)).map(state => state.state);
      return matchingStates.join(', ');
    },
    getStates() {
      const states = this.doctorData.coveredstate.map(coveredState => coveredState.state);
      return states.join(', ');
    },
    async updateReassignment() {
      try {
        this.alert.show = false;
        this.buttonDisabled = true;
        // Sort doctors by selected
        const doctorlist = this.selectedDoctors.filter(val => {
          return val != null;
        });
        if (!doctorlist || doctorlist.length == 0) {
          this.showAlert('Please select at least one doctor to reassign to.');
          this.buttonDisabled = false;
          return;
        }
        const outFrom = Math.round(moment(this.outFrom).format('X')) + this.getSecondsFromTime(this.outFromTime);
        const outTo = Math.round(moment(this.outTo).format('X')) + this.getSecondsFromTime(this.outToTime);
        const body = {
          startdatestamp: outFrom,
          doctorid: this.doctorData.doctorid,
          doctorlist,
          assignmenttype: this.reassignmentType
        };
        if (outTo) {
          body.enddatestamp = outTo;
        }
        const {
          data
        } = await DoctorService.updateReassignment(this.rowData.id, body);
        if (data) {
          if (this.mode == 'approve') {
            await this.approveReassignment(this.rowData.id);
          }
          this.$emit('refresh');
          this.buttonDisabled = false;
          this.showDialog = false;
        }
      } catch (err) {
        this.buttonDisabled = false;
        this.showAlert(err);
      }
    },
    async approveReassignment(id) {
      await DoctorService.approveReassignment(id);
    },
    async refreshDoctorList() {
      if (!this.doctorData.coveredstate) {
        return;
      }
      this.fetchVersion = (this.fetchVersion || 0) + 1;
      const version = this.fetchVersion;
      const states = this.doctorData.coveredstate.map(({
        state
      }) => state);
      this.loadingDoctors = true;
      try {
        const {
          data
        } = await DoctorService.getDoctorsByStateV2(states, this.toMs, this.fromMs, REASSIGNMENT_DISABLED_IN_OPTIONS.OOO, this.reassignmentType);
        if (version !== this.fetchVersion) {
          return;
        }
        const docToRemove = this.doctorData.doctorid;
        this.doctorsByState = data.filter(val => {
          var _val$reassignment_dis3, _val$reassignment_dis4;
          return val.id !== docToRemove && (val.override_reassignment_rule || !((_val$reassignment_dis3 = val.reassignment_disabled_in) !== null && _val$reassignment_dis3 !== void 0 && _val$reassignment_dis3.includes(REASSIGNMENT_DISABLED_IN_OPTIONS.OOO)) && (this.reassignmentType !== REASSIGNMENT_TYPE.PERMANENT || !((_val$reassignment_dis4 = val.reassignment_disabled_in) !== null && _val$reassignment_dis4 !== void 0 && _val$reassignment_dis4.includes(REASSIGNMENT_DISABLED_IN_OPTIONS.PERMANENT_REASSIGNMENT))));
        });
        const previouslySelected = new Set(this.selectedDoctors.filter(id => id != null));
        this.selectedDoctors = this.doctorsByState.map(doctor => previouslySelected.has(doctor.id) ? doctor.id : null);
      } finally {
        if (version === this.fetchVersion) {
          this.loadingDoctors = false;
        }
      }
    },
    formattedDate(date) {
      return date ? moment(date).format('dddd, MMMM D, YYYY') : '—';
    },
    formattedTime(time) {
      return time ? moment(time, 'HH:mm:ss').format('h:mm A') : '';
    },
    async refreshDoctorList() {
      if (!this.doctorData.coveredstate) {
        return;
      }
      this.fetchVersion = (this.fetchVersion || 0) + 1;
      const version = this.fetchVersion;
      const states = this.doctorData.coveredstate.map(({
        state
      }) => state);
      const {
        data
      } = await DoctorService.getDoctorsByStateV2(states, this.outTo ? moment(this.outTo).valueOf() : undefined, moment(this.outFrom).valueOf());
      if (version !== this.fetchVersion) {
        return;
      }
      const docToRemove = this.doctorData.doctorid;
      this.doctorsByState = data.filter(val => val.id !== docToRemove && !val.reassignment_disabled);
      const previouslySelected = new Set(this.selectedDoctors.filter(id => id != null));
      this.selectedDoctors = this.doctorsByState.map(doctor => previouslySelected.has(doctor.id) ? doctor.id : null);
    }
  }
};